export default function ($router: any, routeTo: any) {
  const routeData = $router.resolve(routeTo);
  window.open(routeData.href, '_blank');
}
